<template>
  <div class="notifications-list">
    <Header title="Inbox"></Header>
    <div class="container">
      <div class="notifications-container">
        <div
          class="no-unread-messages"
          v-if="!hasUnread && notifications.length > 0"
        >muito bem, nenhuma mensagem não lida :)</div>

        <div class="read-all-messages" v-if="hasUnread && notifications.length > 0">
          <b-button
            size="sm"
            variant="outline-warning"
            @click.prevent="readAll"
          >marcar todas como lidas</b-button>
        </div>

        <div
          v-for="notification in notifications"
          :key="notification.id"
          :class="{ notificationCard: true, opened: notification.opened }"
        >
          <div class="notification-date">recebido em {{notification.created_at_friendly}}</div>

          <div class="notification-sender">
            <router-link :to="{ name: 'UserSingle', params: { id: notification.sender.to_param }}">
              <div class="user-image">
                <b-img
                  rounded="circle"
                  width="16"
                  :src="notification.sender.avatar"
                  :alt="notification.sender.nickname"
                />
              </div>
              <span>{{notification.sender.nickname}}</span>
            </router-link>
          </div>

          <div class="notification-preview">
            <router-link
              :to="{ name: 'NotificationSingle', params: { id: notification.id }}"
              class="forum-link"
            >
              <span v-html="notification.friendly_subject"></span>
            </router-link>
          </div>

          <!-- <small v-if="notification.opened" :title="notification.opened_at_friendly" v-b-tooltip.hover>sim</small>
          <span v-else>não</span>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "NotificationList",
  metaInfo: {
    title: "Notificações / Mensagens"
  },
  data() {
    return {
      notifications: []
    };
  },
  computed: {
    hasUnread: function() {
      return this.notifications.find(notification => !notification.opened);
    }
  },
  methods: {
    initialize() {
      this.$http
        .get("notifications.json")
        .then(response => (this.notifications = response.data));
    },
    readAll() {
      this.$http.get("notifications/mark_all_as_read.json").then(response => {
        this.$store.dispatch(
          "updateNotificationsCount",
          response.data.unread_count
        );
        this.initialize();
      });
    }
  },
  mounted() {
    this.initialize();
  },
  components: {
    Header
  }
};
</script>

<style lang="sass">
$green: #62c462
$blue: #008EB4
$red: #770000
@keyframes pulseLive
  0%
    opacity: .8
    box-shadow: 0 0 0 1px lighten($green, .8)
  50%
    box-shadow: none
    opacity: 1
  100%
    opacity: .8
    box-shadow: 0 0 0 1px lighten($green, .8)
.notifications-page
  // background: #fafafa
  .main-header
    margin-bottom: 0
  .notifications-container
    @media (min-width: 600px)
      margin: 20px 10%

    .no-unread-messages
      text-align: center
      margin: 20px
      padding: 10px
      color: $green
      font-size: 18px
    
    .read-all-messages
      text-align: center
      margin: 20px
      padding: 10px

    .notificationCard
      border: 1px solid #ddd
      border-radius: 4px
      border-left: 4px solid $green
      margin: 5px
      padding: 10px
      font-weight: bold
      position: relative
      background: rgba(255, 255, 255, .04)

      &:hover 
        transform: scale(1.03)
        transition: all 0.2s ease
        opacity: 1

      &:not(.opened):after 
        content: ''
        height: 5px
        width: 5px
        background: $green
        position: absolute
        top: 11px
        right: 10px
        border-radius: 100%
        animation: pulseLive .8s ease infinite
      
      &:not(.opened):before
        content: 'NÃO LIDA'
        color: #CCC
        font-family: 'Oswald', monospace
        font-size: 11px
        position: absolute
        top: 7px
        right: 20px

      .notification-date
        font-size: 12px
      .notification-sender
        // display: flex
        a
          height: 40px
          width: auto
          color: #666
          .user-image
            display: inline-block
          span
            font-size: 12px
            position: relative
            left: 5px
            top: 2px

      .notification-preview
        a
          color: white

      &.opened
        border-left: 4px solid #ccc
        font-weight: normal



  .message-container
    background: #ccc

</style>
